
module.exports = {
    serverUrl: `http://localhost:8080`,
    serverPrefixUrl: '/tree',
    loginMaintainenceTime: 10800,
    excuteAlarmTime : 300,
}